import React from 'react';
import { Notification } from "rbx";
import { Link } from "react-router-dom";
import UserService from '../../../services/user';
import { unMask } from '../../../commons/masks';
import Controls from '../../components/Controls/Controls';
import useForm from '../../components/useForm';

function ForgotPasswordForm() {
  const {
    values,
    status,
    setStatus,
    stateButton,
    setStateButton,
    handleInputChange
  } = useForm( {cpf_cnpj: ''} );

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStateButton("loading");
    try {
      const response = await UserService.forgotPassword({cpf_cnpj: unMask(values.cpf_cnpj)});
      setStatus(['success', `${response.status}: ${response.data.message}`]);
    } catch(e) {
      if (e.response)
        setStatus(['danger', `${e.response.status}: ${e.response.data.errors}`]);
      else
        setStatus(['danger', `${e.message}`]);
    }
    setStateButton("")
  }

  return (
    <form onSubmit={e => handleSubmit(e)}>
      { status!=='' && <Notification color={status[0]}>{status[1]}</Notification> }
      <Controls.CpfCnpjField 
        label="CPF ou CNPJ:"
        name="cpf_cnpj"
        placeholder='123.456.789-01'
        value={values.cpf_cnpj}
        onChange={handleInputChange}
        focus={true}
        required
      />
      <Controls.ActionButton 
        buttonState={stateButton}
        buttonName='Enviar email para redefinir senha'
        color='custom-purple'
        className='is-fullwidth is-medium'
      />
      <Link to="/login">Entrar</Link>
    </form>
  )
}

export default ForgotPasswordForm;
